import { render } from "./WelcomeText.vue?vue&type=template&id=092a7c93"
import script from "./WelcomeText.vue?vue&type=script&lang=js"
export * from "./WelcomeText.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__